<div>
  <ul class="note-list">
    @for (note of notesService.notes$ | async; track note) {
      <li class="note">
        <mat-form-field class="note-text">
          <textarea
            matInput
            [disabled]="note.user.id !== user.id"
            [value]="note.note_text"
          #noteText></textarea>
        </mat-form-field>
        @if (user?.id === note.user.id) {
          <button
            mat-icon-button
            (click)="saveNote(note, noteText.value)"
            >
            <mat-icon>save</mat-icon>
          </button>
        }
        <span class="updated">
          <span class="date">{{ note.created | date: "MM/dd/yyyy - " }}</span>
          <span class="user">{{ note.user.person?.name }}</span>
        </span>
        @if (user?.id === note.user.id) {
          <button
            mat-icon-button
            (click)="deleteNote(note)"
            >
            <mat-icon>delete</mat-icon>
          </button>
        }
      </li>
    }
  </ul>
  <button (click)="addNote()" mat-raised-button class="add-note-button">
    Add note
  </button>
</div>
